module.exports = __webpack_public_path__ + "9e08fbeec4012bff47f1ba886da330f4.png";